import { Component, OnInit, QueryList, ViewChildren } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { BaseComponent } from "src/app/core/abstracts/base.component";
import { RoleModel } from "src/app/core/models/role.model";
import { distinctUntilChanged, filter, map } from "rxjs/operators";
import { ResultModel } from "src/app/core/models/result.model";
declare var $: any;

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent extends BaseComponent implements OnInit {
  roles: any[] = [];
  role: string = "";
  tenantCode = "";
  userName: string = "";
  isPerasis: boolean = false;
  isVisibleChangePasswordModal: boolean = false;
  forceChangePassword: boolean = false;
  
  filename;

  ngOnInit() {
    this.filename = new Date().getTime();

    this.isPerasis = this.authService.hasRole('PERASIS');

    this.role = this.authService.getRole();


    if (this.isPerasis) {
      this.roles = this.authService.getRoles().filter(r => r.RoleSystemDescription != "PERASIS");
    } else{
      this.roles = this.authService.getRoles();
    }

    this.tenantCode = this.authService.getData("TenantCode");

    this.userName = this.authService.getUserName();

    this.forceChangePassword = this.authService.shouldForceChangePassword();

  }

  changeRole(role: string) {
    if (this.authService.hasRole(role)) {
      this.authService.setRole(role);
      this.role = role;
    }
  }

  getRoleUrl() {
    if (this.role == "ADMIN") {
      return "/yonetim";
    } else if (this.role == "INSTRUCTOR") {
      return "/egitmen";
    } else if (this.role == "STUDENT") {
      return "/ogrenci";
    }
  }

  ngAfterViewInit() {
    this.selectSidebarElement();
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        distinctUntilChanged()
      )
      .subscribe(() => {
        this.selectSidebarElement();
      });

    $("#sidebar .dropdown-toggle").click(function () {
      $(this).next().collapse("toggle");
    });

    $("#menu-toggle").click(function () {
      $("#wrapper").toggleClass("toggled");
      $("#wrapper").removeClass("toggled-mobile");
    });
    $("#sidebar-wrapper .sidenav-link").click(function () {
      $("#wrapper").addClass("toggled-mobile");
      $("#wrapper").removeClass("toggled");
    });
    $(".sidebar-back").click(function () {
      $("#wrapper").removeClass("toggled");
    });

    if (this.forceChangePassword){
      setTimeout(() => this.showChangePasswordModal());
    }
  }

  selectSidebarElement() {
    var elements = document.getElementById("sidebar").getElementsByTagName("a");
    var currentUrl = this.router.url;

    var foundElement = null;

    $.each($("#sidebar a"), function (key, element) {
      //check if route exists in sidebar element
      if (element.hasAttribute("routerlink")) {
        var elementUrl = element.getAttribute("routerlink");
        if (currentUrl.startsWith(elementUrl)) {
          foundElement = $(element);
        }
      }
    });

    if (foundElement && foundElement.hasClass("selected")) {
      //element already selected
      if (
        foundElement.closest("li").parent().hasClass("collapse") == true &&
        foundElement.closest("li").parent().hasClass("show") == false
      ) {
        foundElement.closest("li").parent().collapse("toggle");
      }
    } else if (foundElement) {
      //remove old selections and select new element
      $("#sidebar li.selected").removeClass("selected");
      foundElement.closest("li").addClass("selected");
      if (
        foundElement.closest("li").parent().hasClass("collapse") == true &&
        foundElement.closest("li").parent().hasClass("show") == false
      ) {
        foundElement.closest("li").parent().collapse("toggle");
      }
    } else {
      //remove old selections
      $("#sidebar li.selected").removeClass("selected");
    }
  }

  public showChangePasswordModal() {
    this.isVisibleChangePasswordModal = true;
  }

  hideModal() {
    this.isVisibleChangePasswordModal = false;
  }

  onChangePassword(result: ResultModel) {
    this.commonFunctionsService.showResultNotification(result);

    if (result.Success == true) {
      this.hideModal();
    }
  }

  logout() {
    this.authService.logOut();
    this.router.navigate(["/"]);
  }
  onImgError(event){
    event.target.src = './assets/logo/logo.svg?v=' + this.filename ;
  }
}
